import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, switchMap } from 'rxjs';
import { TimesheetService } from '../../service/timesheet.service';
import { AnagraficaTimesheet } from '../../interfaces/timesheet.interface';
import { FiltroService } from '../../service/filtro.service';
import { AppService } from '../../service/app.service';
import { TipologicheService } from '../../service/tipologiche.service';
import { tipologicaInterface } from '../../interfaces/tipologica.interface';
import { RettificheService } from '../../service/rettifiche.service';
import { Rettifica } from '../../interfaces/rettifica.interface';

export const riepilogoModificheResolver: ResolveFn<{
  anagraficaTimeSheet: AnagraficaTimesheet;
  elencoModifiche: Rettifica[];
  elencoModificheCount: number;
  commesse: tipologicaInterface[];
  uoPrimoLivello: tipologicaInterface[];
}> = (route, state) => {
  const timesheetService = inject(TimesheetService);
  const rettificheService = inject(RettificheService);
  const filtroService = inject(FiltroService);
  const appService = inject(AppService);
  const tipologicheService = inject(TipologicheService);
  return filtroService.ultimoFiltroRiepilogoModifiche(appService.attore).pipe(
    switchMap((filtro: any) => {
      return forkJoin({
        anagraficaTimeSheet: timesheetService.getAnagraficaTimeSheet(),
        elencoModifiche: rettificheService.riepilogoRettifiche(filtro),
        elencoModificheCount: rettificheService.riepilogoRettifiche(filtro, true),
        commesse: tipologicheService.get('commesseDestinazione'),
        uoPrimoLivello: tipologicheService.get('unitaPrimoLivello')
      });
    })
  );
};

